mutation CreatePromocode($input: CreatePromocodeInput!) {
  createPromocode(input: $input) {
    id
    title
    createdAt
    updatedAt
  }
}
